module.exports = __webpack_public_path__ + "img/lg_ring_y_o_null_null@3x.21a00592.png";